import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { Field, change, reduxForm } from 'redux-form';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired, validateNumber } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import {
  clearOrganizationCharts,
  getOrganizationCharts,
} from '../../../../actions';

export const MaintenanceTaskForm = ({ handleSubmit, loading, edit }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Descripción" required>
          <Field
            name="description"
            component={TextInput}
            type="text"
            placeholder="Descripción"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Horas de Trabajo" required>
          <Field
            name="workingHours"
            component={TextInput}
            type="text"
            placeholder="Horas de Trabajo"
            validate={[isRequired, validateNumber]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Código">
          <Field
            name="companyMaintenanceTaskId"
            component={TextInput}
            type="text"
            placeholder="Código"
          />
        </FormItem>
      </FormGroup>
      {edit && (
        <FormGroup row>
          <FormItem label="Estado">
            <Label>
              <Field name="active" component="input" type="checkbox" /> Activo
            </Label>
          </FormItem>
        </FormGroup>
      )}

      <FormFooter />
    </Form>
  );
};

MaintenanceTaskForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  edit: PropTypes.bool,
};

MaintenanceTaskForm.defaultProps = {
  loading: false,
  edit: false,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  loading: !MechanicalMaintenanceUnit.MaintenanceTask.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetOrganizationCharts: getOrganizationCharts,
  dispatchClearOrganizationCharts: clearOrganizationCharts,
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'MaintenanceTaskForm',
})(MaintenanceTaskForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
